import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'pt-form-actions',
  template: `
    <div class='w-100 form-actions-container'>

      <pt-button-with-loader
        [disabled]='saveButtonDisabled'
        [loading]='saveButtonLoading && !asDefault'
        [label]="'BUTTON.SAVE' | translate"
        (buttonWithLoaderClick)='save(false)'
        [cssClass]='saveButtonClass'
        [mainIcon]='saveButtonMainIcon'
      ></pt-button-with-loader>

      <pt-button-with-loader *ngIf="enabledSaveAsDefault"
        class="ms-2"
        [disabled]='saveButtonDisabled'
        [loading]='saveButtonLoading && asDefault'
        [label]="'BUTTON.SAVE_AS_DEFAULT' | translate"
        (buttonWithLoaderClick)='save(true)'
        [cssClass]='saveButtonClass'
        [mainIcon]='saveButtonMainIcon'
      ></pt-button-with-loader>

      <button type='button'
              (click)='resetClick.emit()'
              [ngClass]='resetButtonClass'
              class='btn btn-outline-secondary btn-sm ms-2' *ngIf="!enableSimpleMode">
        {{resetLabel}}
      </button>
    </div>
  `,
  styles: [
    `
      .form-actions-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
      }
    `
  ]
})
export class FormActionsComponent {

  @Input() enabledSaveAsDefault = false;

  @Input() saveButtonMainIcon: string;
  @Input() saveButtonClass: string;
  @Input() saveButtonLoading: boolean;
  @Input() saveButtonDisabled: boolean;

  @Input() resetLabel: string;
  @Input() resetButtonClass: string;

  @Output() resetClick = new EventEmitter<any>();
  @Output() submitClick = new EventEmitter<any>();
  @Output() submitClickAsDefault = new EventEmitter<any>();

  public asDefault = false;
  public enableSimpleMode = false;

  save(asDefault: boolean) {
    this.asDefault = asDefault;
    if (asDefault) {
      this.submitClickAsDefault.emit(true);
    } else {
      this.submitClick.emit(true);
    }
  }

  constructor() {
    //todo @georgy
    // condizione temporale mentre si migrano le notifiche
    const pathName = window.location.href;
    const rgx = new RegExp(/.*data-protection-governance\/.*\/.*|.*administration-configuration(\/.*\/.*|\/setting(\?at=2){0).*/gm);
    this.enableSimpleMode = rgx.test(pathName);
  }
}
